import c from "../common";

export default {
  titletext: c.BBS_title.en,
  Logout: c.Logout.en,

  //Iontoolbar
  language: c.language.en,
  name: c.name.en.uppercase,
  nickname: c.nickname.en,
  phone: c.phone.en,
  email: c.email.en,

  //Buttons
  NewVendor: "Add New " + c.vendor.en.uppercase,
  ChangePassword: "Change Password",

  //Tabs
  Vendor: c.vendor.en.uppercase,
  ApprovedMer: "Approved " + c.vendor.en.uppercase,
  NewApplication: "New " + c.vendor.en.uppercase + " Application",
  AllEvent: "All Event",

  //tags
  hidden: c.hidden.en,
  Unapprove: "Processing",
  NA: "NA",
  Product: "Product",
  ComingSoon: "Coming Soon",
};
